import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

const FilterIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 12V19.88C14.04 20.18 13.94 20.5 13.71 20.71C13.6175 20.8027 13.5076 20.8762 13.3866 20.9264C13.2657 20.9766 13.136 21.0024 13.005 21.0024C12.874 21.0024 12.7444 20.9766 12.6234 20.9264C12.5024 20.8762 12.3925 20.8027 12.3 20.71L10.29 18.7C10.1809 18.5934 10.098 18.463 10.0477 18.319C9.9974 18.175 9.98107 18.0213 10 17.87V12H9.97001L4.21001 4.62C4.04762 4.41153 3.97434 4.14726 4.0062 3.88493C4.03805 3.6226 4.17244 3.38355 4.38001 3.22C4.57001 3.08 4.78001 3 5.00001 3H19C19.22 3 19.43 3.08 19.62 3.22C19.8276 3.38355 19.962 3.6226 19.9938 3.88493C20.0257 4.14726 19.9524 4.41153 19.79 4.62L14.03 12H14Z" />
  </svg>
);

const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
  padding-left: 16px;
`;

const StyledTitle = styled.p`
  display: flex;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
`;

const StyledIconButton = styled(IconButton)`
  && {
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 40px;
    height: 40px;
    padding: 8px;
    fill: ${(props) => props.fillcolor};
  }
`;

const StyledFiltersCounter = styled.div`
  position: absolute;
  width: 25px;
  height: 24px;
  border-radius: 16px;
  background-color: #e42313;
  right: -8px;
  top: -8px;
  font-size: 14px;
  color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledMenuItem = styled(MenuItem)`
  && {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    margin-left: 16px;
    margin-right: 16px;
    padding-left: 8px;
    padding-right: 0;
    border-bottom: 1px solid #e6e6e6;
    font-size: 14px;
    color: ${(props) => (props.selected ? "#1A1A1A" : "#666666")};
  }
`;

const FiltersDropdown = ({ items, handleChange, filters }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleIconClick = (event) => {
    items.length && setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);

  return (
    <div>
      <div>
        <StyledIconButton
          onClick={handleIconClick}
          fillcolor={isOpen ? "#F2F2F2" : "#333333"}
          style={{ backgroundColor: isOpen ? "#1A1A1A" : "#FFF" }}
        >
          <FilterIcon />
          {filters.length > 0 && (
            <StyledFiltersCounter>{filters.length}</StyledFiltersCounter>
          )}
        </StyledIconButton>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            width: "100%",
            marginTop: "7px",
            paddingBottom: "32px",
          },
        }}
        MenuListProps={{ disablePadding: true }}
      >
        <StyledTitleContainer>
          <StyledTitle>
            <FormattedMessage id={"eo.filters"} defaultMessage={"Filters"} />:
          </StyledTitle>
          <IconButton edge="end" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </StyledTitleContainer>
        {items.map((item) => {
          const isSelected = filters.includes(String(item.id));
          return (
            <StyledMenuItem
              key={item.id}
              onClick={() => handleChange(item.id)}
              selected={isSelected}
            >
              <FormattedMessage
                id={item.translationKey}
                defaultMessage={item.name}
              />
              <Checkbox checked={isSelected} />
            </StyledMenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default FiltersDropdown;
